
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/efdelta-recall-reception",
      function () {
        return require("private-next-pages/efdelta-recall-reception/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/efdelta-recall-reception"])
      });
    }
  